<template>
  <div
    class="partials-container grid-x align-top grid-margin-x"
    :class="partials[0].name !== 'HeroComponent' ? 'not-hero' : ''"
  >
    <component
      v-inview:class="{'blur': false}"
      v-for="(partial, key) in partials"
      :key="key"
      :payload="partial.payload"
      :is="partial.name"
      class="small-12 cell partial"
      :class="{
          'large-3' : (partial.cols === 1 || !partial.cols) && partial.name !== 'HeroComponent' && partial.name !== 'CaseStudyComponent',
          'large-6' : (partial.cols === 2) && partial.name !== 'HeroComponent' && partial.name !== 'CaseStudyComponent',
          'large-9' : (partial.cols === 3) && partial.name !== 'HeroComponent' && partial.name !== 'CaseStudyComponent',
          'large-12' : (partial.cols === 4) && partial.name !== 'HeroComponent' && partial.name !== 'CaseStudyComponent' || partial.name === 'Breadcrumbs',
          'partial-margins is-not-hero' : partial.name !== 'HeroComponent',
          'blur': key !== 0
        }"
    ></component>
  </div>
</template>
<script>
import HeroComponent from "@partials/HeroComponent";
import HtmlTextComponent from "@partials/HtmlTextComponent";
import TitleComponent from "@partials/TitleComponent";
import GalleryTextComponent from "@partials/GalleryTextComponent";
import SliderGalleryComponent from "@partials/SliderGalleryComponent";
import SpaziatoreComponent from "@partials/SpaziatoreComponent";
import CaseStudyComponent from "@partials/CaseStudyComponent";
import VideoComponent from "@partials/VideoComponent";
import IframeComponent from "@partials/IframeComponent";
import Breadcrumbs from "@components/global/Breadcrumbs";

export default {
  components: {
    HeroComponent,
    HtmlTextComponent,
    TitleComponent,
    GalleryTextComponent,
    SliderGalleryComponent,
    SpaziatoreComponent,
    CaseStudyComponent,
    VideoComponent,
    IframeComponent,
    Breadcrumbs
  },
  props: {
    partials: {
      required: true,
      type: Array
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.partials-container {
  @include breakpoint(medium down) {
    margin-left: 0;
    margin-right: 0;
    .partial {
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    }
    .partial:not(.main-cell) {
      padding-left: 32px;
      padding-right: 32px;
    }
  }
  &.not-hero {
    padding-top: 64px;
  }
}
.partial-margins {
  margin-top: 64px;
  margin-bottom: 64px;
  @include breakpoint(medium down) {
    margin-top: 32px;
    margin-bottom: 32px;
  }
}
.partial.is-not-hero {
  @media (max-width: 1220px) and (min-width: 1024px) {
    max-width: calc(1024px - 128px);
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  filter: blur(0px);
  opacity: 1;
  transition: opacity 1.25s, filter 0.6s;
  -o-transition: opacity 1.25s, filter 0.6s;
  -moz-transition: opacity 1.25s, filter 0.6s;
  -webkit-transition: opacity 1.25s, filter 0.6s;
  &.blur {
    filter: blur(3px);
    opacity: 0;
  }
}
</style>
